"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressApi = void 0;
class AddressApi {
    constructor(postcode, housenumber, addition = '') {
        this.apiKey = 'WWm9Ochxeu-IMGDc5JwO2dV2FwTNcklTDYkdHkehUCY';
        this.requestUrlBase = 'https://geocode.search.hereapi.com/v1/geocode';
        this.requestUrl = '';
        this.address = '';
        this.country = 'Nederland';
        this.postcode = postcode;
        this.houseNumber = housenumber;
        this.addition = addition;
        this.buildRequestUrl();
    }
    buildRequestUrl() {
        this.requestUrl = this.requestUrlBase;
        this.requestUrl += '?q=' + this.postcode;
        this.requestUrl += '+' + this.houseNumber;
        this.requestUrl += '+' + this.country;
        if (this.addition != undefined && this.addition != '') {
            this.requestUrl += this.addition;
        }
        this.requestUrl += '&apiKey=' + this.apiKey;
    }
    async doRequest() {
        const response = await fetch(this.requestUrl, {
            method: 'GET',
        });
        const result = await response.json();
        if (result !== undefined) {
            return result.items[0];
        }
        return null;
    }
    async getAddress() {
        const address = await this.doRequest();
        if (address !== null) {
            return {
                city: address.address.city,
                street: address.address.street,
            };
        }
        return null;
    }
}
exports.AddressApi = AddressApi;
